import { useTranslate } from '../../../../hooks/useTranslate';
import { useSembonusUser } from '../../../../providers/UserProvider';
import { ListItem } from '../../Footer.styles';
import type { AuthProps } from '../../Footer.types';
import { StyledButton } from './TravelAgentItem.styles';

export const TravelAgentItem = ({ onAuthClick }: AuthProps) => {
  const { t } = useTranslate();
  const { userInfo } = useSembonusUser();

  if (userInfo?.member.travelAgencyId) {
    return null;
  }

  return (
    <ListItem>
      <StyledButton type="button" onClick={() => onAuthClick('footer')}>
        {t('login.loginForTravelAgencies')}
      </StyledButton>
    </ListItem>
  );
};
